export const lightTheme = {
  bg: "#F8F9FA",
  bgLight: "#FFFFFF",
  primary: "#6C5CE7",
  secondary: "#A29BFE",
  text_primary: "#2D3436",
  text_secondary: "#636E72",
  card: "#FFFFFF",
  card_light: "#F8F9FA",
  button: "#6C5CE7",
  button_hover: "#5F4FD1",
  white: "#FFFFFF",
  black: "#000000",
  shadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
  shadow_lg: "0 8px 24px rgba(0, 0, 0, 0.12)",
  green: "#00B894",
  yellow: "#FDCB6E",
  orange: "#E17055",
  red: "#D63031",
};

export const darkTheme = {
  bg: "#0F0F0F",
  bgLight: "#1A1A1A",
  primary: "#A29BFE",
  secondary: "#6C5CE7",
  text_primary: "#FFFFFF",
  text_secondary: "#B2BEC3",
  card: "#1A1A1A",
  card_light: "#2D2D2D",
  button: "#A29BFE",
  button_hover: "#8B7FE8",
  white: "#FFFFFF",
  black: "#000000",
  shadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
  shadow_lg: "0 8px 24px rgba(0, 0, 0, 0.4)",
  green: "#00B894",
  yellow: "#FDCB6E",
  orange: "#E17055",
  red: "#D63031",
};
